/* ==========================================================================
   Elevate Floors — Seção 04: Your material or ours

   Um único número comanda tudo: o progresso p, de 0 a 1, derivado da posição
   da seção na tela. p=0 quando o topo dela está a 90% da altura da janela;
   p=1 depois que ela subiu 75% de uma tela. Curso curto de propósito — o
   efeito precisa completar antes de a seção sair do campo de visão.

   O hover SOMA ao scroll em vez de substituí-lo: ao sair do hover o cartão
   volta ao valor do scroll, não a zero.

   O JS não escreve transform: escreve custom properties. A transição está
   declarada no CSS, então o navegador interpola sozinho e o JS nunca briga
   com a folha de estilo.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initSection(section) {
    if (section._efMatBound) return;
    section._efMatBound = true;

    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-card]'));
    if (!cards.length) return;

    // com movimento reduzido o CSS já põe a lâmina no lugar; não escrever nada
    if (reduce.matches) return;

    var cs = getComputedStyle(section);
    var SLIDE = parseFloat(cs.getPropertyValue('--ef-mat-slide')) || 26;
    var LIFT = parseFloat(cs.getPropertyValue('--ef-mat-lift')) || -14;
    var HOVER_SLIDE = SLIDE + 4;
    var HOVER_LIFT = -8;

    var hovered = null;
    var ticking = false;
    var progresso = cards.map(function () { return 0; });

    /* O progresso é medido CARTÃO A CARTÃO, não pela seção inteira.

       Com um progresso só para a seção, no mobile — onde os cartões ficam
       empilhados — o de cima aparecia quando a conta ainda estava perto de 0 e
       quase não animava, enquanto o de baixo só entrava na tela com a conta já
       em 1 e mostrava o efeito inteiro. Era o mesmo número servindo dois
       elementos que cruzam a tela em momentos diferentes.

       No desktop os dois cartões ficam lado a lado, com retângulos praticamente
       iguais, então medir por cartão dá o mesmo resultado de antes. */
    function progressoDe(el) {
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var raw = (vh * 0.9 - r.top) / (vh * 0.75);
      return Math.max(0, Math.min(1, raw));
    }

    function paint() {
      cards.forEach(function (card, i) {
        var plank = card.querySelector('[data-plank]');
        var face = card.querySelector('[data-face]');
        var on = hovered === i;
        var p = progresso[i];

        var y = on ? HOVER_SLIDE : p * SLIDE;
        // a opacidade termina antes do fim do curso: o último trecho é só
        // movimento, o que fica mais elegante
        var o = on ? 1 : Math.min(1, p * 1.4);
        var fy = p * LIFT + (on ? HOVER_LIFT : 0);

        if (plank) {
          plank.style.setProperty('--plank-y', y.toFixed(1) + 'px');
          plank.style.setProperty('--plank-o', o.toFixed(2));
        }
        if (face) face.style.setProperty('--face-y', fy.toFixed(1) + 'px');
      });
    }

    function measure() {
      ticking = false;
      var mudou = false;
      cards.forEach(function (card, i) {
        var next = progressoDe(card);
        if (Math.abs(next - progresso[i]) > 0.01) {
          progresso[i] = next;
          mudou = true;
        }
      });
      if (mudou) paint();
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(measure);
    }

    cards.forEach(function (card, i) {
      card.addEventListener('mouseenter', function () { hovered = i; paint(); });
      card.addEventListener('mouseleave', function () { hovered = null; paint(); });
      // no toque não existe hover: o clique alterna o mesmo estado
      card.addEventListener('click', function () {
        hovered = hovered === i ? null : i;
        paint();
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    measure();
    paint();
  }

  function init() {
    document.querySelectorAll('[data-material]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
